import { AxiosService } from './axios.service'

const baseURL = 'origem-do-cadastro'

/**
 * Defines the API methods for register source
 */
export default class RegisterSourceService {
	/**
	 * List the register sources
	 * @return {Promise<any>} The register source list
	 */
	static listRegisterSources() {
		return AxiosService.get(`${baseURL}/listar`).then(({ data }) => data)
	}
}
